import { render, staticRenderFns } from "./SearchNavItemCompany.vue?vue&type=template&id=3fcffed4&scoped=true&"
import script from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
export * from "./SearchNavItemCompany.vue?vue&type=script&lang=js&"
import style0 from "./SearchNavItemCompany.vue?vue&type=style&index=0&id=3fcffed4&prod&scoped=true&lang=css&"
import style1 from "./SearchNavItemCompany.vue?vue&type=style&index=1&id=3fcffed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcffed4",
  null
  
)

export default component.exports